module.exports = __webpack_public_path__ + "img/img_banner_project_lingquan.8bcd98d9.jpg";